
export const BUILD_INFO = {
  version: "0.15.0",
  buildDate: "2026-11-04T13:11:09.116Z",
  gitCommit: "99cc21f",
  gitCommitFull: "99cc21f3c26f7605d6317a6ed7081c25f811ee95",
  gitBranch: "deploy/deposits-dev",
  gitCommitMessage: "test(admin): give the parties spec the deposit protection signal",
  gitAuthor: "mehrdokhtgohar",
  gitCommitDate: "2026-11-04T12:58:38Z",
  nodeVersion: "v22.14.0"
} as const;
